import axios from '@service'
import { GET_PROJECT_MODULE_COMPLETENESS } from './api'
import { HTTP_ERR_SUCCESS } from '@constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@constant/error'

// 获取项目对应模块是否已完善
export default async function getProjectModuleCompleteness(payload = {}, config = {}) {
    const param = {
        ...GET_PROJECT_MODULE_COMPLETENESS,
        ...config,
        params: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
